import {z} from 'zod'
import * as schemas from './services/guest.schema'

export type SubscriptionsV3 = z.infer<typeof schemas.SubscriptionsSchemaV3>
export type SubscriptionsToRenewCreditCardV3 = z.infer<typeof schemas.SubscriptionsSchemaToRenewCardV3>
export type SubscriptionV3 = z.infer<typeof schemas.SubscriptionSchemaV3>
export type SubscriptionsUpdateV3 = z.infer<typeof schemas.SubscriptionsUpdateSchemaV3>
export type AgesType = z.infer<typeof schemas.AgesSchema>

export enum SubscriptionsStatusE {
    Active = 'active',
    Inactive = 'inactive',
    Cancel = 'cancel',
    Failed = 'failed'
}

export enum SubscriptionsKeysE {
    Subscriptions = 'subscriptions',
    Errors = 'errors'
}

export enum OnBoardStepsE {
    Step_one = 'step_one',
    Step_two = 'step_two',
    Step_three = 'step_three'
}

export enum OnBoardDataTypesE {
    Personal = 'personal',
    Generic = 'generic'
}

export enum HostFiltersTabIdsE {
    CHAT_TOPICS = 'chatTopics',
    ACTIVITIES = 'activities',
    COUNTRY_LANGUAGE = 'countryLanguage',
    SPECIAL_HOST_CATEGORY = 'specialHostCategory',
    GENDER = 'gender'
}

export type StepComponentProp = {
    images?: (string | undefined | null)[]
    avatar?: string
    hostname?: string | string[]
    type?: OnBoardDataTypesE
}
